import React from 'react';
import DefaultImg from "../../assets/img/default-image.svg";
import Roles from '../../models/roles';
import { useAppSelector } from '../../store';
import { TJobData } from '../../store/candidate/types';
import { TVacancy, TVacancyDetail } from '../../store/vacancy/types';

interface CentreImageProps {
    vacancy?: TVacancy | TJobData | TVacancyDetail;
    width?: string;
    height?: string;
    isCandidateFilledAllForms?: boolean;
    documentsExpired?: boolean;
    imageUrl?: string | null;
    isDocumentsExpired?: boolean;
}

const CentreImage: React.FC<CentreImageProps> = ({ 
    vacancy, width, height, isCandidateFilledAllForms = true, imageUrl, documentsExpired, isDocumentsExpired  
}) => {

    const user = useAppSelector((state) => state.auth.user);

    let imageFullUrl = vacancy && vacancy?.centre?.photo;
    if(!vacancy){
        imageFullUrl = imageUrl ? imageUrl : "";
    }

    return (
        <>
            {imageFullUrl && imageFullUrl.length > 0 ? (
                <div
                    style={{
                        borderRadius: '50%',
                        overflow: 'hidden',
                        width: width || "50px",
                        height: height || "50px",
                        display: 'inline-block'
                    }}
                >
                    <img
                        alt="Centre Profile"
                        width={width || "50px"}
                        height={height || "50px"}
                        className={`img-responsive object-fit-cover ${(!isCandidateFilledAllForms || documentsExpired || isDocumentsExpired) ? ' blurred' : ''}`}
                        src={imageFullUrl}
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            ...((!isCandidateFilledAllForms || documentsExpired || isDocumentsExpired) && user?.role.name === Roles.CANDIDATE ? { filter: 'blur(2.5px)' } : {})
                        }}
                    />
                </div>
            ) : (
                <div
                    style={{
                        borderRadius: '50%',
                        overflow: 'hidden',
                        width: width || "50px",
                        height: height || "50px",
                        display: 'inline-block'
                    }}
                >
                    <img
                        alt="Centre Profile"
                        width={width || "50px"}
                        height={height || "50px"}
                        className={`img-responsive object-fit-cover ${(!isCandidateFilledAllForms || documentsExpired || isDocumentsExpired) ? ' blurred' : ''}`}
                        src={DefaultImg}
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '100%'
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default CentreImage;